import React from 'react'

import { formField } from 'decorators'

import DateTimePicker from './DateTimePicker'

export default formField(props => <DateTimePicker {...props} />)
